import { useContext, useEffect, useMemo } from 'react';
import { SidebarContext } from './SidebarContext';
/**
 * React hook for showing the sidebar. Any value that whose change should trigger a
 * render should be passed as "input"
 */
export const useSidebar = (component, inputs = [component]) => {
    const sidebar = useMemo(() => component, [component]);
    const context = useContext(SidebarContext);
    const { showSidebar, hideSidebar, isVisible: isSidebarShown, replaceComponent, revertComponent } = context;
    useEffect(() => {
        replaceComponent(sidebar);
        return () => revertComponent();
    }, [replaceComponent, sidebar, revertComponent]);
    return { showSidebar, hideSidebar, isSidebarShown };
};
//# sourceMappingURL=useSidebar.js.map